import { render, staticRenderFns } from "./header-mobile.vue?vue&type=template&id=def8aeb2&scoped=true"
import script from "./header-mobile.vue?vue&type=script&lang=js"
export * from "./header-mobile.vue?vue&type=script&lang=js"
import style0 from "./header-mobile.vue?vue&type=style&index=0&id=def8aeb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def8aeb2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
